import React from 'react';
import Navbar from '../components/Navbar';
import Card from '../components/ui/card';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background cyber-grid">
      <Navbar />
      <div className="container mx-auto px-4 py-20 max-w-4xl">
        <Card glow className="p-8 md:p-12 backdrop-blur-xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
            Privacy Policy
          </h1>
          <p className="text-xs text-muted-foreground mb-8">Last Updated: May 2026</p>

          <div className="space-y-6 text-sm md:text-base text-muted-foreground leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-foreground mb-2">1. Information We Collect</h2>
              <p>
                When you create an account, we collect standard operational authentication details including your email address, full name, and encrypted password profiles. For users logging in via Google OAuth 2.0, we retrieve basic authorized identification payloads (such as public avatar URLs and verified unique Google sub-IDs) to provision persistent local sessions.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground mb-2">2. Scraped Social Media Telemetry</h2>
              <p>
                Bot-Hunter strictly analyzes **publicly accessible** social media interactions. Scraped user profiles, target metadata, and sampled tweet payloads generated by external accounts are archived within an independent, access-controlled MongoDB Atlas Database Cluster dedicated exclusively to continuous model inference. We do not access, process, or evaluate protected or private user accounts.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground mb-2">3. Cookies and Browser Caching</h2>
              <p>
                We use strict client-side JSON Web Tokens (JWT) preserved securely inside browser Local Storage alongside automatic UI routing configurations. Analytics events are captured globally via standard enhanced measurement signals to audit system usability trends.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-foreground mb-2">4. Data Security & Storage Separation</h2>
              <p>
                Your personal registered credentials reside inside an isolated application database decoupled directly from our bulk scraping compute workflows. We safeguard password hashes using optimized Bcrypt salting libraries and encrypt all client-to-server traffic layers with standard SSL/TLS protocol policies.
              </p>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
